var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"information-space"},[_c('b-container',{staticClass:"main-container"},[_c('information-space-item',{attrs:{"date":"2023/12/8","information":"会社情報を更新しました。"}}),_c('information-space-item',{attrs:{"date":"2023/3/5","information":"ホームページをリニューアルしました。"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }